import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=b279eff0"
import script from "./customPage.vue?vue&type=script&lang=js"
export * from "./customPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports